import { PricingTeaserComponent } from './PricingTeaserComponent';

/**
 * Campaign variant B. Was a bare re-export of {@link PricingTeaserComponent} —
 * it had to become a real wrapper to opt into the campaign price typography
 * (SH-415), since setting it on the shared component would have changed
 * variant A too.
 */
export function PricingTeaserComponentB(
  props: React.ComponentProps<typeof PricingTeaserComponent>,
) {
  return <PricingTeaserComponent {...props} campaignPricing />;
}
